// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"LockedContent_wrapper__XnLAm","purchase":"LockedContent_purchase__2wBHr","purchase__link":"LockedContent_purchase__link__3L5vI"};